export const agentsConstants = {
    AGENTS_FETCH: 'AGENTS_FETCH',
    AGENTS_SUCCESS: 'AGENTS_SUCCESS',
    AGENTS_ERROR: 'AGENTS_ERROR',
    AGENTS_UPDATE: 'AGENTS_UPDATE',
};

export const agentsLookupConstants = {
    AGENTS_LOOKUP_FETCH: 'AGENTS_LOOKUP_FETCH',
    AGENTS_LOOKUP_SUCCESS: 'AGENTS_LOOKUP_SUCCESS',
    AGENTS_LOOKUP_ERROR: 'AGENTS_LOOKUP_ERROR',
};

export const AgentStatus = {
    Disabled: 0,
    Active: 1,
};
